<template>
    <div v-if="updateAvailable" class="update-prompt-overlay" @click="dismissUpdate">
        <div class="update-prompt-card" @click.stop>
            <div class="update-prompt-header">
                <h4>App Update Available</h4>
            </div>
            <div class="update-prompt-body">
                <p>A new version of Warren is available with improvements and bug fixes.</p>
                <p>Would you like to update now?</p>
            </div>
            <div class="update-prompt-actions">
                <button @click="applyUpdate" class="btn btn-primary update-prompt-confirm">
                    Update Now
                </button>

                <button @click="dismissUpdate" class="update-prompt-cancel">
                    Later
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "UpdatePrompt",
    computed: {
        ...mapState(["updateAvailable"]),
    },
    methods: {
        ...mapActions(["applyUpdate", "dismissUpdatePrompt"]),
        dismissUpdate() {
            this.dismissUpdatePrompt();
        },
    },
};
</script>

<style scoped>
/* mirrors ConfirmPrompt.vue so both overlays read as the same dialog */
.update-prompt-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.update-prompt-card {
    background: #1c1c1c;
    border: 1px solid #2c2c2c;
    border-radius: 14px;
    padding: 18px 16px 8px;
    max-width: 350px;
    width: 90%;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
}

.update-prompt-header h4 {
    margin: 0 0 6px 0;
    color: #fff;
    font-size: 17px;
    font-weight: 600;
}

.update-prompt-body p {
    margin: 0 0 6px 0;
    color: #c9cdd1;
    font-size: 14px;
    line-height: 1.4;
}

.update-prompt-confirm {
    display: block;
    width: 100%;
    height: 46px;
    margin-top: 12px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
}

.update-prompt-cancel {
    display: block;
    width: 100%;
    height: 42px;
    margin-top: 4px;
    border: 0;
    background: none;
    color: #9aa0a6;
    font-size: 15px;
}
</style>
